/**
 * @file 号码类型反馈
 * @author hukeke01
 */
import React, {Fragment} from 'react';
import InputFormItem from '../../components/InputFormItem/index';
import SelectFormItem from '../../components/SelectFormItem';
import RadioFormItem from '../../components/RadioFormItem/index';

interface INumFeedbackProps {
    phoneList: Array<string>;
    phone: string | [];
    setPhone(e: any): void;
    curStep: number;
    questionType: {
        questionType: string;
        questionTypeErr: string;
    };
    setQuestionType: (value: any) => void;
    setDesc: (value: any) => void;
    desc: {
        desc: string;
        descErr: string;
    }
}
export default function NumFeedback(props: INumFeedbackProps) {
    const {phoneList, phone, setPhone, questionType, setQuestionType, setDesc, desc} = props;
    const options = [{
        label: '空号',
        value: 1
    }, {
        label: '无法接通',
        value: 4
    }, {
        label: '非该企业/政府号码',
        value: 2
    }, {
        label: '其他',
        value: 3
    }];

    return (<Fragment>
        {phoneList.length > 0
            ? <SelectFormItem
                title="问题号码"
                isMsgRequired
                placeholder="请选择"
                type="phone"
                data={phone}
                phoneList={phoneList}
                onChange={value => setPhone({
                    phone: value,
                    phoneErr: ''
                })}
                style={{width: '424px'}}
            />
            : <InputFormItem
                title="问题号码"
                isMsgRequired
                placeholder="请输入问题号码"
                type="phone"
                data={phone}
                onChange={e => setPhone({
                    phone: e.target.value.length ? [].concat(e.target.value.replace(/\s+/g, '')) : [],
                    phoneErr: ''
                })}
                onBlur={e => setPhone({
                    phone: e.target.value.length ? [].concat(e.target.value.replace(/\s+/g, '')) : [],
                    phoneErr: ''
                })}
                style={{width: '424px'}}
            />
        }
        <RadioFormItem
            title="问题类型"
            isMsgRequired
            direction="vertical"
            type="questionType"
            options={options}
            data={questionType}
            onChange={e => {
                setQuestionType({
                    questionType: e.target.value,
                    questionTypeErr: ''
                });
                setDesc({
                    ...desc,
                    descErr: ''
                });
            }}
        />
    </Fragment>);
}